<script>
import UserResource from '@/resources/user'
import ChargeResource from '@/resources/charge'
import PaymentMethod from '../components/PaymentMethod.vue'
import CostBreakdown from '../components/CostBreakdown.vue'
import UserEditForm from '../components/UserEditForm.vue'
import messages from '@/mixins/messages'

export default {
    name: 'Profile',
    mixins: [messages],
    components: {
        PaymentMethod,
        CostBreakdown,
        UserEditForm
    },
    data() {
        return {
            userResource: null,
            loading: true,
        }
    },
    async mounted() {
        this.userResource = await UserResource.detail(this.$store.getters.userId)
        this.loading = false
    },
}
</script>

<template>
    <div>
        <header-image offsety="78%" src="hero-main4.png">
            <h1>Profil</h1>
        </header-image>
        <b-container class="mt-3" fluid="lg" v-if="!loading">
            <b-row>
                <b-col md="6" offset-md="3" class="mt-2 mb-5">
                    <b-card bg-variant="light" title="Profil" class="mt-5">
                        <b-card-text>
                            <user-edit-form :userResource="userResource" submitText="Enregistrer" successMessage="Profil enregistré !" />
                        </b-card-text>
                    </b-card>
                </b-col>
            </b-row>
        </b-container>
    </div>
</template>

<style lang="scss" scoped>
.add-card {
    padding-top: 10px;
}
</style>
